import { createSelector, createStructuredSelector } from "reselect";
import { Application } from "types/Dashboard";
import { initialState, State as DashboardState } from "./redux";
import {
  selectTnCForCidpUser,
  selectHasUserAcceptedTnC,
} from "scenes/selectors";

/**
 * Direct selector to the dashboard state domain
 */

export const selectDashboardDomain: (any) => DashboardState = (state) =>
  state.dashboard || initialState;

export const selectLoadingApplications = createSelector(
  selectDashboardDomain,
  (substate) => substate.loadingApplications
);

export const selectApplicationsForRedirect = createSelector(
  selectDashboardDomain,
  (substate) => {
    const { applications } = substate;
    if (applications === null) {
      return [];
    }

    return applications;
  }
);

export const selectApplications = createSelector(
  selectDashboardDomain,
  (substate) => {
    const { applications } = substate;
    if (applications === null) {
      return [];
    }

    const applicationsList = Object.values(applications ?? {});

    const appListArray: Array<Application> = [];
    if (applicationsList.length !== 0) {
      applicationsList.forEach((appArr) => {
        const arr = appArr.filter((app) => app.type !== "API");
        appListArray.push(...arr);
      });
    }
    return appListArray;
  }
);

export const selectNoApplications = createSelector(
  selectApplications,
  (appsList) => appsList.length === 0
);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  updatedTnC: selectTnCForCidpUser,
  hasUpdatedTnCAccepted: selectHasUserAcceptedTnC,
  tncForCidpUser: selectTnCForCidpUser,
  noApplications: selectNoApplications,
  applications: selectApplications,
  loadingApplications: selectLoadingApplications,
  applicationListForRedirect: selectApplicationsForRedirect,
});
